import { Game, MainInterface } from './game';

import 'bootstrap';
import './app.scss';

window.onload = () => {
    const mainInterface = new MainInterface();
}
